import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UpdateMeterReadingComponent } from './update-meter-reading/update-meter-reading.component';

@Component({
  selector: 'view-history',
  templateUrl: './view-history.component.html',
  styleUrls: ['./view-history.component.scss']
})
export class ViewHistoryComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ViewHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public Historydata: any, private readonly dialog: MatDialog) {
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
      custom: [{ name: 'Delete', title: '<i class="fa  fa-trash"></i>' }],
      position: 'right'
    },
    columns: {
      odometerDate: {
        title: 'Odometer Date'
      },
      odometerReading: {
        title: 'Odometer Reading'
      },
      hoursDate: {
        title: 'Hours Date'
      },
      hours: {
        title: 'Hours'
      },
      lastUpdatedBy: {
        title: 'Last Updated By'
      },
      lastUpdateDate: {
        title: 'Last Update Date'
      },
      source: {
        title: 'Source'
      }
    }
  };

  data = [
    {
      odometerDate: "10/1/2018",
      odometerReading: "100",
      hoursDate: "10/1/2018",
      hours: "10",
      lastUpdatedBy: "465",
      lastUpdateDate: "10/1/2018",
      source: "UserUpdate"
    }
  ];

  public showUpdateDialog(): void {
    this.dialog.open(UpdateMeterReadingComponent, {
      height: 'auto',
      maxHeight: '90%',
      width: '50%',
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      data: {}
    });
  }
}
